export default __webpack_public_path__ + "static/media/kr.3890f198.jpg";